import Request from "../../model/Request";
import Response from "../../model/Response";
import {RestClient} from "../../util/RestClient";
import {Config} from "../../util/Config";
import TopupProduct from "../../entities/productOrder/topup/TopupProduct";

export module ProductService {
    export async function get(): Promise<Response<TopupProduct[]>> {
        const url = Config.get("GET_PRODUCTS_URL");
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const productsData = response.data;
            if (productsData) {
                const data = productsData.map((t: any) => new TopupProduct(t.id, t.name, t.amount, t.enabled));
                return new Response<TopupProduct[]>(true, data, response.error)
            }
        }
        return new Response<TopupProduct[]>(false, undefined, response.error, response.status);
    }

    export async function getAll(): Promise<Response<TopupProduct[]>> {
        const url = Config.get("GET_ALL_PRODUCTS_URL");
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const productsData = response.data;
            if (productsData) {
                const data = productsData.map((t: any) => new TopupProduct(t.id, t.name, t.amount, t.enabled));
                return new Response<TopupProduct[]>(true, data, response.error)
            }
        }
        return new Response<TopupProduct[]>(false, undefined, response.error, response.status);
    }

    export async function updateEnabled(topupProductId: string, enabled: boolean, providerProductId?: string): Promise<Response<any>> {
        const url = Config.get("UPDATE_PRODUCT_ENABLED_URL", {id: topupProductId});
        const request = new Request(url, {enabled, productId: providerProductId});
        return await RestClient.put(request);
    }
}